/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingpublished1Inputs */

const en_crosspostingpublished1 = /** @type {(inputs: Crosspostingpublished1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published to Facebook.`)
};

const de_crosspostingpublished1 = /** @type {(inputs: Crosspostingpublished1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf Facebook veröffentlicht.`)
};

/**
* | output |
* | --- |
* | "Published to Facebook." |
*
* @param {Crosspostingpublished1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingpublished1 = /** @type {((inputs?: Crosspostingpublished1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingpublished1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingpublished1(inputs)
	return de_crosspostingpublished1(inputs)
});
export { crosspostingpublished1 as "crosspostingPublished" }